export const SUCCESS = 'SUCCESS';
export const INFO = 'INFO';
export const ERROR = 'ERROR';
